// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 66 ? "dc112a36" : chunkId) + "." + {"66":"1b420b0d3dbef8a5","223":"3a33ebcb9690a4e5"}[chunkId] + ".js";
};